<script>
    import { tweened } from "svelte/motion";
    import { createEventDispatcher } from 'svelte';

    export let original = 90; // TYPE NUMBER OF SECONDS HERE

    const dispatch = createEventDispatcher();

    let timer = tweened(original);

    setInterval(() => {
        if ($timer > 0) $timer--;
    }, 1000);

    $: seconds = Math.floor($timer);

    $:{
        if(seconds<1) dispatch('finalizo');
    }
</script>

<main class="w3-center">
    {#if timer < 1}
        <div class="w3-center">esperando el tiempo...</div>
    {:else}
        <h1>
            <span class="secs">{seconds} </span>
        </h1>
        <progress value={$timer / original} />
    {/if}
</main>

<style>
    main {
        width: 600px;
        margin: 0 auto;
    }

    progress {
        display: block;
        width: 100%;
    }

    .secs {
        color: darkgoldenrod;
    }
</style>
